import Icon from './arrow-counter-clockwise.svg?react'
import { createIcon } from './factory'

export const ArrowCounterClockwise = createIcon({
  regular: Icon,
  bold: Icon,
  fill: Icon,
  duotone: Icon,
})
